// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eEag","largestCol":"styles_largestCol__1iirC","smallestCol":"styles_smallestCol__PrVxK"};